import api from "../../../src/utils/api";

export const fetchViolationStatuses = () => {
  return api.get("/statuses/violations");
};
